import { api } from "../Apis/interceptor";

export const getCustomer = function (currCustomer) {
  return api.get(`/api/v1/customer/${currCustomer}`);
};

export const getClientList = function (currCustomer) {
  const noCacheParam = `_=${Date.now()}`; // or use Math.random()
  return api.get(`/api/v1/clientList/?cust_id=${currCustomer}&${noCacheParam}`);
};


export const getCustomerFields = function (currCustomer) {
  return api.get(`/api/v1/customerField/${currCustomer}`);
};

export const getLogo = function (currCustomer) {
  return api.get(`/api/v1/getLogo/${currCustomer}`);
};

export const getCustomerControlField = function (currCustomer) {
  return api.get(`/api/v1/customerControlField/${currCustomer}`);
};
export const list = function () {
  return api.get("/api/v1/customerlist");
};

export const filter = function (skip, limit) {
  return api.get("/api/v1/customer_filter", {
    params: { skip: skip, limit: limit },
  });
};

export const reference = function (customer_id, reset) {
  return api.get("/api/v1/customerref/" + customer_id + "/" + reset);
};
export const client = function (customer_id) {
  return api.get("/api/v1/clientdata/" + customer_id);
};
export const labelConfig = function (customer_id, reset) {
  return api.put("/api/v1/customerLabelConfig/" + customer_id + "/" + reset);
};

export const FieldConfig = function (customer_id, reset) {
  return api.put("/api/v1/customerFieldConfig/" + customer_id + "/" + reset);
};
export const CntrlPanelEditConfig = function (customer_id, reset) {
  return api.put("/api/v1/cntrlPanelEditConfig/" + customer_id + "/" + reset);
};
export const CntrlPanelLabelConfig = function (customer_id) {
  return api.put("/api/v1/cntrlPanelLabelConfig/" + customer_id);
};

export const updateControlConfig = function (cust_id, cntrlConfig) {
  return api.put("/api/v1/updateControlConfig/" + cust_id, {
    cntrlConfig: cntrlConfig,
  });
};

export const ConfirmControlReset = function (customer_id) {
  return api.put("/api/v1/resetControlPanelConfig/" + customer_id);
};

export const passwordExpr = function (customer_id, passwordExpiryLimit) {
  return api.put("/api/v1/updatePasswordExpiry/" + customer_id, {
    limit: passwordExpiryLimit,
  });
};

export const newVersion = function (customer_id, pageName) {
  return api.get("/api/v1/createNewVersion/" + customer_id + "/" + pageName);
};

export const updateVersion = function (customer_id, customerData) {
  return api.put("/api/v1/updateVersion/" + customer_id, customerData);
};

export const createnew = function (customerData) {
  return api.post("/api/v1/customer/", customerData);
};

export const checkCustomerEmail = function (customerData, c_id) {
  return api.post("/api/v1/checkCustomerEmail", {
    externalEmailData: customerData,
    customer_id: c_id,
  });
};

export const update1 = function (id, optionData) {
  return api.put("/api/v1/options/" + id, optionData);
};

export const delete1 = function (id) {
  return api.delete("/api/v1/options/" + id);
};

export const get = function (id) {
  return api.get("/api/v1/customer/" + id);
};

export const byName = function (id, searchVal) {
  return api.get("/api/v1/byName/" + searchVal + "/" + id);
};

export const update = function (id, customerData) {
  return api.put("/api/v1/customer/" + id, customerData);
};

export const updateuser = function (id, customerData) {
  return api.put("/api/v1/customerUser/" + id, customerData);
};

export const getPageLike = function (pattern) {
  return api.get("/api/v1/customerLike/" + pattern);
};

export const deleteCustomer = function (id) {
  return api.delete("/api/v1/customer/" + id);
};

export const otherFactors = function (customer_id) {
  return api.get("/api/v1/otherFactors/" + customer_id);
};
export const updateRefOption = function (customer_id, index, options) {
  return api.put("/api/v1/updateRefOption/" + customer_id, {
    index: index,
    options: options,
  });
};

export const updateRef = function (customer_id, customerData) {
  return api.put("/api/v1/updateRef/" + customer_id, customerData);
};
// updateRefLabelOpp
export const updateRefLabelOpp = function (customer_id, Data) {
  return api.put("/api/v1/updateRefLabelOpp/" + customer_id, Data);
};

export const updateStage = function (id, stages) {
  return api.put("/api/v1/updateStage/" + id, stages);
};

export const retunToDefaultLogo = function (id) {
  return api.put("/api/v1/retunToDefaultLogo/" + id);
};

export const resetOption = function (id, option_names) {
  return api.put("/api/v1/resetOption/" + id, { option_names: option_names });
};

export const addNewField = function (customer_id, fieldData) {
  return api.put("/api/v1/addNewField/" + customer_id, fieldData);
};

export const updateDetails = function (id, customerData) {
  return api.put("/api/v1/customerDetails/" + id, customerData);
};

export const updateBranch = function (id, branchData) {
  return api.put("/api/v1/updateBranch/" + id, branchData);
};

export const getPendingUsers = function (id, flag) {
  return api.get("/api/v1/customer_users/" + id + "/" + flag);
};

export const sendPendingMails = function (cust_name, users) {
  return api.post("/api/v1/sendPendingMails", {
    cust_name: cust_name,
    users: users,
  });
};

export const updateCompetitor = function (
  customer_id,
  competitor_name,
  branch_id,
  branch_key
) {
  return api.put(
    "/api/v1/updateCompetitor/" +
      customer_id +
      "/" +
      competitor_name +
      "/" +
      branch_id +
      "/" +
      branch_key
  );
};

export const getCompetitors = function (customer_id, branch_id, branch_key) {
  return api.get(
    "/api/v1/getCompetitors/" + customer_id + "/" + branch_id + "/" + branch_key
  );
};

export const getCustBranch = function (id) {
  return api.get("/api/v1/customer_branches/" + id);
};

export const getUsers = function (type, cust_id) {
  return api.get("/api/v1/usersByCustomer/" + type + "/" + cust_id);
};

export const saveRestrictedTabs = function (id, app_tabs, user_tabs) {
  return api.put("/api/v1/savePipelineTabs/" + id, {
    app_tabs: app_tabs,
    user_tabs: user_tabs,
  });
};

export const generateToken = function (cust_id) {
  return api.put("/api/v1/generateToken/" + cust_id);
};

export const updateRolePermissions = function (id, role_name) {
  return api.put("/api/v1/updateRolePermissions/" + id, {
    role_name: role_name,
  });
};

export const saasCustomer = function (customerData) {
  return api.post("/api/v1/saasCustomer/", customerData);
};

/*To load the customer dropdown list*/
export const loadDropdown = function () {
  return api.get("/api/v1/loadDropdown");
};

/*To load the customer dropdowns*/
export const getCustomerNames = function () {
  return api.get("/api/v1/getCustomerNames");
};

/*To load the customer specific winplan Template*/
export const getTemplate = function (cust_id) {
  return api.get("/api/v1/getTemplate/" + cust_id);
};

export const saveTemplate = function (cust_id, template) {
  return api.put("/api/v1/saveTemplate/" + cust_id, { template: template });
};
export const UpdateWinPlanTemplate = function (
  cust_id,
  section,
  theme,
  themeDescription
) {
  return api.put("/api/v1/UpdateWinPlanTemplate/" + cust_id, {
    Section: theme,
    Theme: section,
    ThemeDescription: themeDescription,
  });
};
//update logout time
export const updateLogoutTime = function (cust_id, log_out_time) {
  return api.put("/api/v1/updateLogoutTime/" + cust_id, {
    log_out_time: log_out_time,
  });
};
//get logout time
export const getLogoutTime = function (cust_id) {
  return api.get("/api/v1/getLogoutTime/" + cust_id);
};

//update rds data
export const updateRds = function (customer_id, reset) {
  return api.get("/api/v1/customerRds/" + customer_id + "/" + reset);
};

//add new Rds
export const addNewRdsField = function (customer_id, fieldData) {
  return api.put("/api/v1/addNewRdsField/" + customer_id, fieldData);
};
//update rds
export const updateRdsPanel = function (customer_id, customerData) {
  return api.put("/api/v1/updateRdsPanel/" + customer_id, customerData);
};
//reset rds field
export const resetRdsOption = function (id, option_name) {
  return api.put("/api/v1/resetRdsOption/" + id, { option_name: option_name });
};
//search rds
export const byNameRds = function (id, searchVal) {
  return api.get("/api/v1/byNameRds/" + searchVal + "/" + id);
};

export const updateFieldConfig = function (customer_id, fieldData) {
  return api.put("/api/v1/updateFieldConfig/" + customer_id, fieldData);
};

export const addInFieldConfig = function (customer_id, fieldData) {
  return api.put("/api/v1/addInFieldConfig/" + customer_id, fieldData);
};

export const updateFieldConfigOrder = function (customer_id, fieldData) {
  return api.put("/api/v1/updateFieldConfigOrder/" + customer_id, fieldData);
};

export const updateCustomerOrder = function (customer_id, fieldData) {
  return api.put("/api/v1/updateCustomerOrder/" + customer_id, fieldData);
};
export const updateColor = function (customer_id, color) {
  return api.post("/api/v1/uploadColor/" + customer_id, { color });
};
